import React from 'react';
import ProductSelector from './ProductSelector';
import { GUARANTEE_PRODUCT_LIST } from '../constants/productFamily';
import {
  useGuaranteeProduct,
  useGuaranteeTheme,
} from '../hooks/useGuaranteePurchases';

const SELECT_PRODUCT_PLACEHOLDER = 'SELECT PRODUCT';

const GuaranteeProductSelector = () => {
  const [selectedProduct, handleProductChange] = useGuaranteeProduct();
  const themeClass = useGuaranteeTheme();

  return (
    <ProductSelector
      products={GUARANTEE_PRODUCT_LIST}
      selectedProduct={selectedProduct}
      onProductChange={handleProductChange}
      hasUnsavedChanges={false}
      tooltipContent='Select the product to filter guarantee purchases.'
      placeholderText={SELECT_PRODUCT_PLACEHOLDER}
      themeClass={themeClass}
    />
  );
};

export default GuaranteeProductSelector;
